import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import VueNativeSock from 'vue-native-websocket'
import VueFriendlyIframe from 'vue-friendly-iframe'

axios.defaults.withCredentials = true
Vue.use(VueAxios, axios)
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueFriendlyIframe)
Vue.use(VueNativeSock, 'wss://wss.sipuni.com/api', {store: store, format: 'json'})

const domainReplace = (url) => {
  return url;
};

Vue.axios.interceptors.request.use(config => {
  config.url = domainReplace(config.url);
    if (config.method.toUpperCase() === 'POST' || config.method.toUpperCase() === 'PATCH' || config.method.toUpperCase() === 'PUT')
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
    return config;
});
Vue.axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response && error.response.status === 401) {
        const msg = {
            event: 'notAuthorized',
            data: {}
        };
        parent.postMessage(msg, '*');
    }
    return null;
});
new Vue({
    router,
    store,
    render: h => h(App),
    mounted() {
        this.$store.dispatch('loadFunnels');
        this.$store.dispatch('handleTlgUpdates')
    },
}).$mount('#app')

